import React from 'react';

import { SLogoPayPo } from './styles';

import Section from '../../layout/Section';

const SectionLogo = () => (
    <Section alignItems='flex-start'>
        <SLogoPayPo />
    </Section>
);

export default SectionLogo;
